import Vue from 'vue'
import Vuex from 'vuex'
import socketio from 'socket.io-client'
import ioreq from 'socket.io-request'
const ss = require('socket.io-stream')
const nuid = require('nuid')

Vue.use(Vuex)

const PORT = 3031
// const IS_PROD = false
const IS_PROD = process.env.NODE_ENV === 'production'
const SIO_PROD_SERVER = 'https://deti.cdsvyatka.com'
const SIO_DEV_SERVER = `http://${window.location.hostname}:${PORT}`
// eslint-disable-next-line
const UPLOAD_PREFIX = IS_PROD
  ? 'https://deti.cdsvyatka.com/sio/deti/uploads/'
  : SIO_DEV_SERVER + '/uploads/'
// eslint-disable-next-line
const REPORTS_PREFIX = IS_PROD
  ? 'https://deti.cdsvyatka.com/sio/deti/reports/'
  : SIO_DEV_SERVER + '/reports/'
const SIO_SERVER = IS_PROD ? SIO_PROD_SERVER : SIO_DEV_SERVER
const DOMAIN = IS_PROD ? SIO_PROD_SERVER : `http://${window.location.hostname}:${window.location.port}`
const scope = 'deti'

let snackid = 1
let router = null
let tokenUpdates = null

function ts () {
  return (new Date()).getTime()
}

let confirmTo = null
let confirmResolve = null
let confirmReject = null

const state = {
  domain: DOMAIN,
  socket: null,
  connected: false,
  ready: false,
  profile: null,
  group: null,
  route: null,
  snack: null,
  tasksInAction: 0,
  reportsPrefix: REPORTS_PREFIX,
  uploadPrefix: UPLOAD_PREFIX,
  confirmMessage: null,
  user_ip: null
}
const mutations = {
  // NAVIGATION WATCHER
  NAVIGATE: (state, route) => {
    state.route = route
  },
  // SNACKS
  SNACK_SET: (state, { level, msg }) => {
    snackid++
    state.snack = {
      level, snackid, msg
    }
    console.log(level, snackid, msg)
  },
  SNACK_CLEAR: (state, snack) => {
    if (state.snack.snackid === snack.snackid) {
      state.snack = null
    }
  },
  // CONNECTION
  SOCKET: (state, socket) => {
    state.socket = socket
  },
  SOCKET_CONNECTED: (state) => {
    console.log('socket-io: connected')
    state.connected = true
  },
  SOCKET_DISCONNECTED: (state) => {
    console.log('socket-io: disconnected')
    state.connected = false
  },
  AUTH_SUCCESS: (state, profile) => {
    state.profile = profile
    state.ready = true
  },
  AUTH_LOGOUT: (state) => {
    state.profile = null
  },
  AUTH_FAIL: (state) => {
    state.ready = true
  },
  SHURSHIM: (state) => {
    state.tasksInAction++
  },
  POSHURSHALY: (state) => {
    state.tasksInAction--
  },
  CONFIRM_CLOSE: (state) => {
    if (confirmTo) clearTimeout(confirmTo)
    confirmResolve = null
    confirmReject = null
    state.confirmMessage = null
  },
  CONFIRM_ASK: (state, message) => {
    state.confirmMessage = message
  },
  SET_USER_IP: (state, user_ip) => {
    state.user_ip = user_ip
  }
}
const actions = {
  // NAVIGATION WATCHER
  navigate ({ commit }, route) {
    commit('NAVIGATE', route)
  },
  // SNACKS
  async snack ({ commit }, snack) {
    if (snack instanceof Error) {
      commit('SNACK_SET', {
        msg: snack.toString() + (snack.stackhash ? ` <nobr>КОД ОШИБКИ <b>${snack.stackhash}</b></nobr>` : ``),
        level: 'error'
      })
    } else if (snack.level) {
      commit('SNACK_SET', { msg: snack.msg, level: snack.level })
    } else if (snack.msg) {
      commit('SNACK_SET', { msg: snack.msg, level: 'info' })
    } else {
      commit('SNACK_SET', { msg: snack, level: 'info' })
    }
  },
  async snackClear ({ commit }) {
    commit('SNACK_CLEAR')
  },
  // ATTACHMENTS
  uploadAttachment (file) {
    if (!file) return
    const saveAs = nuid.next().slice(-6) + '-' + file.name
    const stream = ss.createStream()
    ss(state.socket).emit('upload-attachment', stream, { size: file.size, saveAs })
    return {
      stream: ss.createBlobReadStream(file).pipe(stream),
      attachment: {
        type: ['.jpg', '.png', '.gif', '.jpeg', '.bmp'].find(x => saveAs.endsWith(x)) ? 'image' : 'document',
        content: UPLOAD_PREFIX + saveAs
      }
    }
  },
  // CONNECTION
  async connect ({ commit, dispatch }, opts) {
    if (opts) router = opts.router
    console.log(`socket-io: connecting ${SIO_SERVER}`)
    let socket = socketio(SIO_SERVER, IS_PROD
      ? { path: '/sio/deti', transports: ['websocket'] }
      : { transports: ['websocket'] }
    )
    const ioreqImpl = ioreq(socket, { event: 'socket.io-request', timeout: 30000 })
    socket['request'] = ioreqImpl.request.bind(ioreqImpl)
    socket['response'] = ioreqImpl.response.bind(ioreqImpl)
    socket.on('connect', async () => {
      commit('SOCKET_CONNECTED')
      commit('SOCKET', socket)
      dispatch('loginByToken')
    })
    socket.on('disconnect', () => {
      commit('SOCKET_DISCONNECTED')
      socket.disconnect()
      dispatch('connect')
    })
    socket.on('joined', pl => console.log('joined', pl))
    // socket.on('added-on', pl => console.log('+on', pl))
    // socket.on('added-response', pl => console.log('+response', pl))
    socket.on('err', err => dispatch('snack', err))
    socket.on('profile', pl => commit('AUTH_SUCCESS', pl))
    socket.on('token', pl => {
      localStorage.setItem('detiToken', pl)
      if (tokenUpdates) clearTimeout(tokenUpdates)
      // обновление токена раз в час
      tokenUpdates = setTimeout(async () => {
        try {
          await dispatch('loginByToken')
        } catch (err) {
          console.log(err)
        }
      }, 60 * 60 * 1000)
    })
    socket.on('user-ip', pl => commit('SET_USER_IP', pl))
    commit('SOCKET', socket)
  },
  // API
  async login ({ commit, dispatch }, login) {
    try {
      login.scope = scope
      const { profile, meta } = await state.socket.request('auth-login', login)
      if (profile) {
        const message = `Выполнен вход: ${meta.as}`
        commit('AUTH_SUCCESS', profile)
        dispatch('snack', message)
        router.push({ path: 'settings' })
      } else {
        commit('AUTH_FAIL')
        console.log('Вход не удался')
      }
    } catch (err) {
      dispatch('snack', err)
    }
  },
  async sberlogin ({ commit, dispatch }, { profile, meta }) {
    try {
      if (profile) {
        const message = `Выполнен вход: ${meta.as}`
        commit('AUTH_SUCCESS', profile)
        dispatch('snack', message)
        setTimeout(() => {
          window.location.replace(`${window.location.origin}/#/settings`)
        }, 0)
      } else {
        commit('AUTH_FAIL')
        console.log('Вход не удался')
      }
    } catch (err) {
      dispatch('snack', err)
    }
  },
  async logout ({ commit }) {
    commit('AUTH_LOGOUT', null)
    localStorage.removeItem('detiToken')
    state.socket.emit('auth-logout')
    console.log('Выполнен выход')
    router.push({ name: 'login' })
    if (tokenUpdates) clearTimeout(tokenUpdates)
  },
  async loginByToken ({ commit, dispatch }) {
    const token = localStorage.getItem('detiToken')
    if (token) {
      try {
        const { profile, meta } = await state.socket.request('auth-login', { token, scope })
        if (profile) {
          const message = `Выполнен вход: ${meta.as}`
          commit('AUTH_SUCCESS', profile)
          dispatch('snack', message)
          if (router.history.current.name === 'Login') router.push({ path: 'settings' })
        } else {
          commit('AUTH_FAIL')
          router.push({ name: 'login' })
          console.log('Вход не удался')
        }
      } catch (err) {
        // случай когда проблемы с сервером и токен удалять не нужно
        if (
          err.toString().startsWith('TimeoutError') ||
          err.toString().startsWith('SocketIOError')
        ) {
          if (tokenUpdates) clearTimeout(tokenUpdates)
          tokenUpdates = setTimeout(() => {
            dispatch('loginByToken')
          }, 5000)
          throw err
        }
        // случай когда сервер не принял токен
        localStorage.removeItem('detiToken')
        router.push({ name: 'login' })
        dispatch('snack', err)
        commit('AUTH_FAIL')
      }
    } else {
      commit('AUTH_FAIL')
    }
    if (!state.profile) {
      const routes = router.options.routes.reduce(
        (r, x) => {
          r[x.name] = x
          return r
        }, {}
      )
      const currentRoute = routes[state.route.name]
      if (currentRoute && currentRoute.needAuth === true) {
        console.log('authorized only')
        router.push({ name: 'login' })
      }
    }
  },
  async updateToken ({ dispatch }) {
    dispatch('loginByToken')
  },
  async sioEmit ({ topic, pl }) {
    // console.log('emit', topic)
    state.socket.emit(topic, pl)
  },
  sioOn ({ topic, cb }) {
    // console.log('sub', topic)
    return state.socket.on(topic, cb)
  },
  sioUnsub ({ topic }) {
    // console.log('unsub', topic)
    return state.socket.removeAllListeners(topic)
  },
  getSocket () {
    return state.socket
  },
  async sioRequest ({ commit }, { topic, pl }) {
    if (!state.connected) throw new Error('Нет связи с сервером. Проверьте подключение')
    const started = ts()
    commit('SHURSHIM')
    try {
      const data = await state.socket.request(topic, pl)
      console.log('OK', ts() - started, 'ms', topic, data.meta)
      return data
    } catch (err) {
      console.log(err.toString(), err.stackhash)
      console.log('FAILED', ts() - started, 'ms', topic, err.stackhash)
      if (err.toString().startsWith('TimeoutError')) throw new Error('Ошибка связи')
      throw err
    } finally {
      commit('POSHURSHALY')
    }
  },
  async confirm ({ commit }, message) {
    commit('CONFIRM_ASK', message)
    return new Promise((resolve, reject) => {
      confirmResolve = resolve
      confirmReject = reject
      confirmTo = setTimeout(() => {
        reject(new Error('Время подтверждения истекло (30 c)'))
        commit('CONFIRM_CLOSE')
      }, 30000)
    })
  },
  confirmConfirm ({ commit }) {
    confirmResolve()
    commit('CONFIRM_CLOSE')
  },
  confirmReject ({ commit }) {
    confirmReject(new Error('действие прервано'))
    commit('CONFIRM_CLOSE')
  },
}

export default new Vuex.Store({
  state, actions, mutations
})
